import { createAction, props } from '@ngrx/store';
import { ICheers, IToastCheers } from 'app/models/cheers';

export const loadCheers = createAction(
  '[Home-Taps Page] Load Cheers'
);

export const upsertOneCheers = createAction(
  '[Home-Taps Page] Upsert Cheers',
  props<{ tap: ICheers }>()
);

export const addToast = createAction(
  '[Cheers] Add Toast',
  props<{ toast: IToastCheers }>()
);

export const removeToast = createAction(
  '[Cheers] Remove Toast',
  props<{ id: string }>()
);

export const executeToastCheckout = createAction(
  '[Cheers] Execute Toast Checkout',
  props<{ toast: IToastCheers }>()
);
